import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  DISABLEProgramCatalogItem,
  DisableProgramCatalogItemPayload,
} from '../requests'

type CategoryData = unknown // The return type of your mutation
type CategoryError = unknown // The error type
type CategoryVariables = unknown // The variables type
type Options = Omit<
  UseMutationOptions<CategoryData, CategoryError, CategoryVariables>,
  'mutationFn'
>

export const useDisableProgramCatalogItem = (options: Options) => {
  return useMutation({
    mutationFn: async (payload: DisableProgramCatalogItemPayload) => {
      return DISABLEProgramCatalogItem(payload)
    },
    mutationKey: [],
    ...options,
  })
}
